import { formatBookingPrice } from "./bookingPrice";

// The API owns payout readiness; missing or unresolved readiness is not public.
export const hasPublicBookingServices = (profile) => profile?.payoutsReady === true
  && Array.isArray(profile.services)
  && profile.services.some((service) => service.isVisible !== false);

// The same booking profile narrowed to one place's services: the profile shows the
// ones marked for it, a link page's Book Me block the ones it explicitly picked.
const withServices = (profile, keep) =>
  profile ? { ...profile, services: (profile.services || []).filter(keep) } : profile;
export const profileBooking = (profile) => withServices(profile, (service) => service.onProfile !== false);
export const blockBooking = (profile, value, variant) => {
  const picked = String(value || "").split(",").filter(Boolean);
  return picked.length || variant === "pick"
    ? withServices(profile, (service) => picked.includes(service.id)) : profile;
};

export const visibleBookingServices = (profile) =>
  (profile?.services || []).filter((service) => service.isVisible !== false);

// One button for any number of services: name and price for one, the starting price for several.
export const bookingSummary = (profile) => {
  const services = visibleBookingServices(profile);
  if (!services.length) return { label: "Book me", meta: "" };
  if (services.length === 1)
    return { label: `Book · ${services[0].name}`, meta: formatBookingPrice(services[0].priceCents) };
  const from = Math.min(...services.map((service) => service.priceCents));
  return { label: "Book me", meta: `from ${formatBookingPrice(from)} · ${services.length} services` };
};
